const CASHMERE_ASSET_BASE_URL =
  "https://ykmk-master.oss-cn-shanghai.aliyuncs.com/wechat/assets/cashmere-2026";

function buildAssetUrl(fileName) {
  return `${CASHMERE_ASSET_BASE_URL}/${fileName}`;
}

export const cashmereAssets = Object.freeze({
  heroTop: buildAssetUrl("hero-top.png"),
  reviewTop: buildAssetUrl("review-top.png"),
  sectionOrganization: buildAssetUrl("section-organization.png"),
  titleTheme: buildAssetUrl("title-theme.png"),
  sectionProcess: buildAssetUrl("section-process.png"),
  sectionAwardsMain: buildAssetUrl("section-awards-main.png"),
  sectionAwardsExtra: buildAssetUrl("section-awards-extra.png"),
  sectionTracks: buildAssetUrl("section-tracks.png"),
  sectionJudgingSubmission: buildAssetUrl("section-judging-submission.png"),
  sectionRights: buildAssetUrl("section-rights.png"),
  sectionSupport: buildAssetUrl("section-support.png"),
  sectionOthers: buildAssetUrl("section-others.png"),
  signupBanner: buildAssetUrl("cashmere-signup-banner.png"),
});

export default cashmereAssets;
